// extracted by mini-css-extract-plugin
export default {"resultContainer":"Result_resultContainer__krG0S","getBack":"Result_getBack__nav5o"};